import React from 'react';
import { helpData, relatedData } from './data';
import './Styles/Container.scss';

const Container=()=>{
    return(
        <div className="help-details-part">
            <div className="data">
                <h1>How to link screens with hotspots</h1>
                <p className="sub">With support for every screen, you can share and present anywhere and quickly gather actionable feedback. </p>
                <div className="details">
                    {helpData.map((d) =>{
                        return(
                            <Section {...d}/>
                        )
                    })}
                </div>
            </div>
            <div className="related">
                <h2>Related articles</h2>
                {relatedData.map((d) =>{
                    return(
                        <Section {...d}/>
                    )
                })}
            </div>
        </div>
    )
};
export default Container ;

export function Section(props){
    return(
        <div className="helpdetails-section">
            {props.title ? <h2>{props.title}</h2> : null}
            {props.desc1 ? <p>{props.desc1}</p> : null}
            {props.desc2 ? <p>{props.desc2}</p> : null}
            {props.desc3 ? <p>{props.desc3}</p> : null}

        </div>
    )
};